module.exports = __webpack_public_path__ + "static/studio-02-f37d1bb7aa9a976a20570bb7a3438cfb.webp";